import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Icon,
  Tooltip,
  Select,
  Switch,
  Checkbox,
  DatePicker,
  InputNumber,
  Modal,
} from "antd";
import { SmartCollectTransactionOrders } from "../../../../models";
import { connect } from "react-redux";
import { alertify, handleApiExceptions } from "../../../../app_methods";
import moment from "moment";
import { cloneDeep } from "lodash";

const PRODUCT_NAME_OPTIONS = [
  { label: "LAP", value: "LAP" },
  { label: "Vehicle", value: "Vehicle" },
];

let OrderForm = (props) => {
  const { form } = props;
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const validations = SmartCollectTransactionOrders.validations;
  const [isGenerating, setIsGenerating] = useState(false);
  const [notifyCustomer, setnotifyCustomer] = useState(true);
  const [payment_type, setPayment_type] = useState();
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  // const paymentType = getFieldValue("payment_type");
  const allowedCollectionModes = getFieldValue("allowed_collection_modes");
  //   const amount = getFieldValue("amount");
  const [date, setDate] = useState(null);
  const [isBankAccountEnabled, setBankAccountEnabled] = useState(false);
  const isCustomUDFForm = [159435, 293012].includes(props?.current_user?.eid);


  const { confirm } = Modal;


  useEffect(() => {

    if (props.order.is_edit) {
        setFormValues();
        return;
    }

    const dynamicForms =
        props?.current_user?.smart_collect_virtual_account_settings?.dynamic_form || [];

    if (dynamicForms.includes("ORDER")) {
        fetchOrderConfiguration();
    }

}, []);

  const changePaymentType = (payment_type) => {
    setPayment_type(payment_type);
    if (payment_type === "single_payment") {
      const amount = getFieldValue("amount");
      if (amount > 0) {
        setFieldsValue({ per_transaction_amount: amount });
      }
    }
  };

  const changeAmount = (event) => {
    if (payment_type === "single_payment") {
      const amount = event.target?.value;
      if (amount > 0) {
        setFieldsValue({ per_transaction_amount: amount });
      }
    }
  };

  let is_upi_creation_enabled =
    props?.current_user?.smart_collect_virtual_account_settings
      ?.enable_virtual_upi_handle_creation;
  let merchant_allowed_payment_modes =
    props?.current_user?.smart_collect_virtual_account_settings
      ?.allowed_payment_modes ?? [];
  let allowed_payment_modes = merchant_allowed_payment_modes;
  const formAllowedPaymentModes = getFieldValue("allowed_payment_modes");
  if (formAllowedPaymentModes && formAllowedPaymentModes.length > 0) {
    allowed_payment_modes = formAllowedPaymentModes;
  }

  let bank_payment_modes = allowed_payment_modes.filter((x) =>
    ["IMPS", "NEFT", "RTGS"].includes(x)
  );
  let merchant_bank_payment_modes = merchant_allowed_payment_modes.filter((x) =>
    ["IMPS", "NEFT", "RTGS"].includes(x)
  );

  const setFormValues = () => {
    const paymentType =
      props.order.amount == props.order.per_transaction_amount
        ? "single_payment"
        : "multiple_payment";

    const valueObject = {
      amount: props.order.amount,
      unique_request_number: props.order.merchant_request_number,
      customer_name: props.order.customer_name,
      customer_email: props.order.customer_email,
      customer_phone: props.order.customer_phone,
      per_transaction_amount: props.order.per_transaction_amount,
      notification_cycle_type: props.order.notification_cycle_type,
      expiry_date: props.order.expiry_date
        ? moment(new Date(props.order.expiry_date))
        : null,
      // dqr_soundbox: props.order.dqr_soundbox,
      dqr_soundbox: false,
      udf1: props.order.udf1,
      udf2: props.order.udf2,
      udf3: props.order.udf3,
      udf4: props.order.udf4,
      udf5: props.order.udf5,
      allowed_collection_modes: props.order.allowed_collection_modes,
      allowed_payment_modes: props.order.allowed_payment_modes,
      key: props.order.id,
      payment_type: paymentType,
      soundbox_ids: props?.order?.notification_settings?.soundbox_ids
    };

    setBankAccountEnabled(
      props.order?.allowed_collection_modes?.includes("bank_account")
    );
    setPayment_type(paymentType);
    form.setFieldsValue(valueObject);
  };
  const fetchOrderConfiguration = async () => {
    try {
        const response =
            await SmartCollectTransactionOrders.get_dynamic_form({
                entity_type: "ORDER",
            });            
        if (!response.success) {
            return;
        }
        const fields = response?.data?.data?.dynamic_forms || [];
        const values = {};
        let shouldGenerateURN = false;
        fields.forEach((field) => {
            let value = field.default_value;
            switch(field.field_name) {
              case "payment_type":
                changePaymentType(value);
                break;
              case "allowed_collection_modes":
                if (typeof value === "string") {
                    value = JSON.parse(value);
                }
                setBankAccountEnabled(value.includes("bank_account"));
                break;
              case "notify_customer_on_create":
                value = value === "true";
                break;
              case "expiry_date":
                if (value) {
                    const [count, unit] = value.split("_");

                    const unitMapping = {
                        hrs: "hours",
                        hour: "hours",
                        hours: "hours",
                        day: "days",
                        days: "days",
                        month: "months",
                        months: "months",
                        year: "years",
                        years: "years",
                    };

                    if (count && unitMapping[unit]) {
                        value = moment().add(Number(count), unitMapping[unit]);
                    } else {
                        value = null;
                    }
                } else {
                    value = null;
                }
                break;
              case "unique_request_number":
                shouldGenerateURN = value === "auto";
                if (value === "manual"){
                  value = undefined
                }
                break;
              case "allowed_payment_modes":
                if (value && typeof value === 'string') {
                  try {
                    value = JSON.parse(value);
                  } catch (e) {
                    console.error("Failed to parse allowed_payment_modes:", e);
                    value = [];
                  }
                }
                break;
              default:
                break;
            }
            if (value !== undefined) {
                values[field.field_name] = value;
            }
        });
        if (shouldGenerateURN) {
            const urnResponse =
                await SmartCollectTransactionOrders.generate_order_urn();

            if (urnResponse.success) {
                values.unique_request_number =
                  urnResponse?.data?.data?.unique_request_number || "";
            }
        }
        form.setFieldsValue(values);
    } catch (error) {
        handleApiExceptions(error);
    }
};


  function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  function getDisabledHours() {
    var hours = [];
    for (let i = 0; i < moment().hour(); i++) {
      hours.push(i);
    }
    return hours;
  }

  function getDisabledMinutes(selectedHour) {
    var minutes = [];
    if (selectedHour === moment().hour()) {
      for (var i = 0; i < moment().minute(); i++) {
        minutes.push(i);
      }
    }
    return minutes;
  }

  function disabledDate(current) {
    return current && current < moment().startOf("day");
  }

  const onSubmit = (e) => {
    e.preventDefault();
    console.log("onSubmit", e);
    form.validateFields((err, values) => {
      console.log("onSubmit", values, props.order);
      if (err) return;
      if (
        parseFloat(form.getFieldValue("per_transaction_amount")) >
        parseFloat(form.getFieldValue("amount"))
      ) {
        alertify(
          "Oops!",
          `Per Transaction Amount exceeds Order amount.`,
          "error"
        );
        return;
      }
      const formData = cloneDeep(form.getFieldsValue());
      if (getFieldValue("allowed_collection_modes").includes("upi")) {
        if (formData.allowed_payment_modes) {
          formData.allowed_payment_modes.push("UPI");
        } else {
          formData.allowed_payment_modes = ["UPI"];
        }
      }
      formData["per_transaction_amount"] = formData.per_transaction_amount
        ? formData.per_transaction_amount
        : null;
      if (props?.current_user?.enable_order_soundbox_notifications) {
        if (form.getFieldValue("soundbox_ids") == undefined || form.getFieldValue("soundbox_ids")?.length == 0)
          confirm({
            title: 'NO SOUNDBOX LINKED',
            content: 'Soundbox ID(s) can be provided for payment announcement. Are you sure you do not want a payment announcement for this order?',
            onOk() {
              props.onSubmit(formData);
            },
            onCancel() { },
          });
        else props.onSubmit(formData);

      }
      else
        props.onSubmit(formData);
    });
  };

  const generateUniqueCode = () => {
    setIsGenerating(true);
    SmartCollectTransactionOrders.generate_order_urn()
      .then((response) => {
        if (response.success)
          form.setFieldsValue({
            unique_request_number: response.data.data.unique_request_number,
          });
        setIsGenerating(false);
      })
      .catch((error) => {
        setIsGenerating(false);
        handleApiExceptions(error);
      });
  };


  const soundboxIDValidator = (rule, values = [], callback) => {
    const soundboxID_regex = /^[a-zA-Z0-9]{6,10}$/;
    const invalidInputs = values.filter((value) => !value.match(soundboxID_regex));
    if (invalidInputs.length === 0) {
      callback();
    } else if (invalidInputs.length === 1) {
      callback(invalidInputs.join("") + " is not a valid soundbox ID");
    } else {
      callback(
        invalidInputs.slice(0, -1).join(", ") +
        " and " +
        invalidInputs.slice(-1) +
        " are not valid soundbox ID"
      );
    }
  };

  const renderUniqueCodeExtra = () => {
    return (
      <Tooltip title="Generate Random">
        <Icon type="setting" spin={isGenerating} onClick={generateUniqueCode} disabled={props.order.is_edit} />
      </Tooltip>
    );
  };

  const paymentTypeOptions =
    props?.current_user?.smart_collect_virtual_account?.vpa_provider_code === "AIRTEL"
      ? [{ label: "Single Payment", value: "single_payment" }]
      : [
        { label: "Single Payment", value: "single_payment" },
        { label: "Multiple Payment", value: "multiple_payment" },
      ];

  return (
    <Form onSubmit={onSubmit}>
      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="Customer Name">
            {getFieldDecorator("customer_name", {
              rules: validations.customer_name,
            })(<Input autoComplete="off" prefix={<Icon type="profile" />} />)}
          </Form.Item>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="Customer Phone">
            {getFieldDecorator("customer_phone", {
              rules: validations.customer_phone,
            })(<Input autoComplete="off" prefix={<Icon type="phone" />} />)}
          </Form.Item>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="Customer Email">
            {getFieldDecorator("customer_email", {
              rules: validations.customer_email,
            })(<Input autoComplete="off" prefix={<Icon type="mail" />} />)}
          </Form.Item>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="Unique request number">
            {getFieldDecorator("unique_request_number", {
              rules: validations.unique_request_number,
            })(
              <Input
                disabled={props.order.is_edit}
                autoComplete="off"
                prefix={<Icon type="audit" />}
                {...!props.order.is_edit && { addonAfter: renderUniqueCodeExtra() }}
              />
            )}
          </Form.Item>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="Amount">
            {getFieldDecorator("amount", {
              rules: validations.amount,
            })(
              <Input
                type="number"
                onChange={(e) => changeAmount(e)}
                disabled={props.order.is_edit}
                autoComplete="off"
                prefix={
                  <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                }
              />
            )}
          </Form.Item>
        </div>

        <div className=" col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="Collection Mode">
            {getFieldDecorator("allowed_collection_modes", {
              rules: validations.allowed_collection_modes,
            })(
              <Checkbox.Group
                onChange={(checkedValues) =>
                  setBankAccountEnabled(checkedValues.includes("bank_account"))
                }
                disabled={props.order?.is_edit}
              >
                {bank_payment_modes.length > 0 ? (
                  <Checkbox value="bank_account">Bank Account</Checkbox>
                ) : null}
                {
                  merchant_allowed_payment_modes.includes("UPI") ? (
                  <Checkbox value="upi">UPI</Checkbox>
                ) : null}
              </Checkbox.Group>
            )}
          </Form.Item>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="Payment Type">
            {getFieldDecorator("payment_type", {
              rules: validations.payment_type,
              placeholder: "Select payment type",
            })(
              <Select
                disabled={props.order.is_edit}
                placeholder="Select payment type"
                onChange={changePaymentType}
              >
                {paymentTypeOptions.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="Per Transaction Amount">
            {getFieldDecorator("per_transaction_amount", {
              rules: validations.per_transaction_amount,
            })(
              <Input
                // type="number"
                autoComplete="off"
                disabled={
                  payment_type === "single_payment" || props.order.is_edit
                }
                prefix={
                  <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                }
              />
            )}
          </Form.Item>
        </div>
      </div>
      {
        isCustomUDFForm && (
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <Form.Item label="Product Name">
                {getFieldDecorator("udf1", {
                rules: validations.product_name,
                placeholder: "Select product name",
              })(
                <Select
                  disabled={props.order.is_edit}
                  placeholder="Select product name"
                >
                  {PRODUCT_NAME_OPTIONS.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6">
            <Form.Item label="Application ID / LAN">
              {getFieldDecorator("udf2", {
                rules: validations.application_id,
              })(<Input disabled={props.order.is_edit} autoComplete="off" />)}
            </Form.Item>
          </div>
        </div>
        )
      }

      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="Notification Cycle">
            {getFieldDecorator("notification_cycle_type", {
              rules: validations.notification_cycle_type,
              initialValue: "",
            })(
              <Select>
                <Select.Option value="">None</Select.Option>
                <Select.Option value="daily">Daily</Select.Option>
                <Select.Option value="weekly">Weekly</Select.Option>
                <Select.Option value="monthly">Monthly</Select.Option>
                <Select.Option value="yearly">Yearly</Select.Option>
              </Select>
            )}
          </Form.Item>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6">
          <Form.Item
            label={`Notify customer on ${props.order.is_edit ? "edit" : "create"
              }`}
          >
            {getFieldDecorator(
              props.order.is_edit
                ? "notify_customer_on_edit"
                : "notify_customer_on_create",
              { initialValue: true ,
                valuePropName: "checked",
              }

            )(
              <Switch
                // checked={notifyCustomer}
                // onChange={() => setnotifyCustomer(!notifyCustomer)}
                //defaultChecked
              />
            )}
          </Form.Item>
        </div>
      </div>

      <div className="row">
        <div className=" col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="Expiry Date">
            {getFieldDecorator("expiry_date", {
              rules: validations.expiry_date,
            })(
              <DatePicker
                onChange={(d) => setDate(d)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm"
                showTime={{
                  disabledMinutes:
                    date && moment() < moment(date)
                      ? undefined
                      : getDisabledMinutes,
                  disabledHours:
                    date && moment() < moment(date)
                      ? undefined
                      : getDisabledHours,
                  format: "HH:mm",
                }}
                disabledDate={disabledDate}
              // disabledDate={(date) => date.valueOf() <= moment().valueOf()}
              />
            )}
          </Form.Item>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6">
          {isBankAccountEnabled ? (
            <Form.Item label="Payment Modes">
              {getFieldDecorator("allowed_payment_modes", {
                rules: [
                  {
                    required: isBankAccountEnabled,
                    message: "Select atleast one.",
                  },
                ],
                ...isBankAccountEnabled && { initialValue: props.order.is_edit ? props.order.allowed_payment_modes : bank_payment_modes }
              })(
                <Select
                  disabled={props.order.is_edit}
                  placeholder="Select Payment Modes"
                  mode="multiple"
                >
                  {merchant_bank_payment_modes.map((key, index) => (
                    <Select.Option key={index} value={key}>
                      {key}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          ) : null}
        </div>

        {props?.current_user?.enable_order_soundbox_notifications ?
          <div className="col-sm-12 col-md-6 col-lg-6">
            <Form.Item label="Collect Soundbox ID">
              {getFieldDecorator("soundbox_ids", {
                rules: [{ validator: soundboxIDValidator }]
              })(
                <Select
                  mode="tags"
                  tokenSeparators={[","]}
                />
              )}
            </Form.Item>
          </div> : null}


      </div>
      {/* <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <Form.Item label="DQR Soundbox">
            {getFieldDecorator("dqr_soundbox", {
              initialValue: false,
              valuePropName: "checked",
            })(
              <Switch />
            )}
          </Form.Item>
        </div>
      </div> */}

    {!props?.order?.is_edit &&
      <div className="row">
          <div className="col-sm-24 col-md-12 col-lg-12">
            <Form.Item label="Transaction Note">
              {getFieldDecorator("transaction_note", {
                rules: validations.transaction_note,
              })(<Input autoComplete="off" prefix={<Icon type="profile" />} />)}
            </Form.Item>
          </div>
        </div>
    }
      <Button
        className="pl-0 mb-2"
        type="link"
        onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
      >
        {showAdvancedOptions
          ? "Hide Advanced Options"
          : "Show Advanced Options"}
        <Icon type={showAdvancedOptions ? "down" : "right"} />
      </Button>

      <div className={showAdvancedOptions ? "display-block" : "display-none"}>
        <div className="d-flex flex-wrap">
          {!isCustomUDFForm && <>
          <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 1">
            {getFieldDecorator("udf1", {
              rules: validations.udf1,
            })(<Input autoComplete="off" prefix={<Icon type="form" />} />)}
          </Form.Item>

          <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 2">
            {getFieldDecorator("udf2", {
              rules: validations.udf2,
            })(<Input autoComplete="off" prefix={<Icon type="form" />} />)}
          </Form.Item>
          </>}
          <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 3">
            {getFieldDecorator("udf3", {
              rules: validations.udf3,
            })(<Input autoComplete="off" prefix={<Icon type="form" />} />)}
          </Form.Item>

          <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 4">
            {getFieldDecorator("udf4", {
              rules: validations.udf4,
            })(<Input autoComplete="off" prefix={<Icon type="form" />} />)}
          </Form.Item>

          <Form.Item style={{ width: "30%" }} label="UDF 5">
            {getFieldDecorator("udf5", {
              rules: validations.udf5,
            })(<Input autoComplete="off" prefix={<Icon type="form" />} />)}
          </Form.Item>
        </div>
      </div>

      <div className="w-100 d-flex justify-content-end mt-4">
        <Button type="primary" htmlType="submit" loading={props.loading}>
          {"Submit"}{" "}
        </Button>
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  current_user: state.userReducer.current_user,
});

OrderForm = Form.create()(OrderForm);

export default connect(mapStateToProps)(OrderForm);
